import type { IMenuOverlayProps } from './IMenuOverlayProps';

/** Прозорий шар на весь екран під відкритим меню верхньої панелі: клік поза меню лише закриває його (прототип v4, z-index 58). */
export function MenuOverlay({ onClose }: IMenuOverlayProps) {
  return <div className="tb-overlay" aria-hidden="true" onClick={onClose} />;
}
